import { render, staticRenderFns } from "./VxBreadcrumb.vue?vue&type=template&id=7f8d27e3&functional=true"
import script from "./VxBreadcrumb.vue?vue&type=script&lang=js"
export * from "./VxBreadcrumb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports